'use client';

import { create } from 'zustand';

export interface FilterState {
  /** Gewählte Kategorie-ID (URL-param: category) */
  categoryId: string | null;
  /** Gewählter Subcategory-Name */
  subcategoryName: string | null;
  /** Gewählte Behandlung */
  treatmentName: string | null;

  // Actions
  setCategoryId: (id: string | null) => void;
  setSubcategoryName: (name: string | null) => void;
  setTreatmentName: (name: string | null) => void;
  resetFilters: () => void;
}

const initialState = {
  categoryId: null,
  subcategoryName: null,
  treatmentName: null,
} as const;

/**
 * Zustand-Store für Drill-Down-Filter (Kategorie → Subcategory → Treatment).
 * Suchbegriff wird separat über nuqs via `useSearch()` verwaltet (URL-persistent).
 * Kategorie-Filter werden hier In-Memory gehandhabt; bei Bedarf kann
 * URL-Sync zusätzlich über nuqs-Hooks in der UI-Schicht erfolgen.
 */
export const useFilterStore = create<FilterState>((set) => ({
  ...initialState,

  setCategoryId: (id: string | null) =>
    set({
      categoryId: id,
      // Subcategory und Treatment zurücksetzen bei Kategoriewechsel
      subcategoryName: null,
      treatmentName: null,
    }),

  setSubcategoryName: (name: string | null) =>
    set({
      subcategoryName: name,
      // Treatment zurücksetzen bei Subcategory-Wechsel
      treatmentName: null,
    }),

  setTreatmentName: (name: string | null) =>
    set({ treatmentName: name }),

  resetFilters: () => set(initialState),
}));
